module.exports = new __parcel__URL__("clickhouse.53526bb6.svg").toString();